import React, { Component } from 'react';
import RoomRatesContainer from './RoomRatesContainer';
import { Tooltip as ReactTooltip } from 'react-tooltip';



export default class RoomTypeContainer extends Component {

    constructor(props) {
        super(props);
        
    }

    render() {
        
        return (
            <div className={'availability-result-container row' + ((this.props.mode === "add" && this.props.selectedRooms.find(sr => sr.roomType?.uId === this.props.roomType.uId)) ? ' hidden' : '') } >
                <RoomTypeImageAndText
                    roomType={this.props.roomType}
                    propertyKey={this.props.propertyKey}
                />
                {this.props.available && 
                <RoomRatesContainer
                    propertyId={this.props.propertyId}
                    propertyKey={this.props.propertyKey}
                    roomType={this.props.roomType}
                    checkIn={this.props.checkIn}
                    nights={this.props.nights}
                    promoCode={this.props.promoCode}
                    adults={this.props.adults}
                    children={this.props.children}
                    select={this.props.select}
                    rooms={this.props.rooms}
                    selectedRooms={this.props.selectedRooms}
                    mode={this.props.mode}
                    />}
                {!this.props.available && <div>Sold Out</div>}
            </div>
           
        );
    }
    
}

export class RoomTypeImageAndText extends Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div className='roomtype-image-and-text-container col'>
                <div className='row'>
                    <div className='roomtype-image-container col-vs-12'>
                        <img className='roomtype-image' src={this.props.roomType.mainImageUrl} alt={this.props.roomType.name} />
                    </div>
                    <div className='roomtype-text-container col-vs-12'>
                        <div className='roomtype-name'>{this.props.propertyKey !== this.props.roomType.propertyKey && <h2> Try our luxury central apartment! </h2>}
                            <h4>{this.props.roomType.name}</h4>
                        </div>
                        <div>
                            {this.props.roomType.shortDescription}
                        </div>
                        <div className='roomType-list'>
                            <ul>
                                <li>size: {this.props.roomType.roomsize} m<sup>2</sup></li>
                                <li>beds: {this.props.roomType.bedConfigurations[0].name}</li>
                            </ul>
                            
                        </div>
                        <div className='roomType-list'>
                                  
                            <AmenityBar
                                amenities={this.props.roomType.facilities}
                                />
                                
                        </div>
                    </div>
                </div>
            </div>

        );
    }

}

export class AmenityBar extends Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div className='amenities-container'>
                
                {
                    this.props.amenities.filter(x => x.iconUrl !== '').map((amenity) => 
                        <div key={amenity.id} className='amenity-container'>
                            <img className='amenity' src={amenity.iconUrl} alt={amenity.name} data-tip={amenity.name} /> {amenity.name}
                        </div>
                    
                    )
                }
            </div>

        );
    }

}